import EditVehicle from './CreateVehicle';

export default EditVehicle;
